import React, { useEffect, useState } from "react";
import home from "../video/tergoldhomevideo.mp4";
import "../css/Homevideo.css";

const HomeVideo = () => {
  const [showText, setShowText] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [showSlogan, setShowSlogan] = useState(false);

useEffect(() => {
  // Show text after 800ms
  const showTimer = setTimeout(() => {
    setShowText(true);
  }, 800);

  // Show slogan after 2.5 seconds
  const sloganTimer = setTimeout(() => {
    setShowSlogan(true);
  }, 2500);

  // Hide text after 8 seconds
const hideTimer = setTimeout(() => {
  setIsVisible(false);
}, 10000); // 10 seconds

  return () => {
    clearTimeout(showTimer);
    clearTimeout(sloganTimer);
    clearTimeout(hideTimer);
  };
}, []);

  return (
    <div className="video-container1">
      <div className="video-wrapper">
        <video
          controls={false}
          className="myvideo"
          autoPlay
          disablePictureInPicture
          loop
          muted
          playsInline
        >
          <source src={home} type="video/mp4" />
        </video>
      </div>
      
      {isVisible && (
        <div className="video-text">
          <h1 className={showText ? "animated-textt" : ""}>
  <span className="welcome-text">Welcome to</span>
  <span className="terra-text"> Terra</span>
  <span className="gold-text"> Gold</span>
</h1>
          
          {/* Slogan that appears from bottom */}
          <div className={`slogan-container ${showSlogan ? 'slogan-visible' : ''}`}>
            <p className="slogan-text">
              Nature's Purest Nutrition, Crafted for Better Living
            </p>
          </div>
        </div>
      )}
      
      {/* SVG wave at the bottom */}
   
    </div>
  );
};

export default HomeVideo;